export default __webpack_public_path__ + "static/media/avatar.eeb5afc5.svg";